<!--Copyright (C) nexleader - All Rights Reserved-->
<!--Unauthorized copying of this file, via any medium is strictly prohibited-->
<!--Proprietary and confidential-->
<!--Written for nexleader <myipsat.com>, 2016-2026-->

<div class="hpanel archetype-dashboard-card">
  <div class="panel-body">
    <h4 class="font-bold m-b-sm">{{ title }}</h4>
    <p class="text-muted m-b-none">{{ description }}</p>
  </div>
  <div class="panel-footer">
    <button
      type="button"
      class="btn btn-link btn-sm p-none"
      (click)="onLearnMore()"
    >
      <i class="fa fa-external-link"></i>&nbsp;&nbsp;{{ ctaText }}
    </button>
  </div>
</div>
